import { createBrowserRouter } from 'react-router';
import { routes } from './routes';

/**
 * Main application router using React Router's data API.
 *
 * Uses createBrowserRouter for:
 * - Route-level loaders for auth checks
 * - Per-route error boundaries
 * - Lazy loading with automatic code splitting
 * - Single source of truth for all routes
 */
export const router = createBrowserRouter(routes, {
  hydrateFallbackElement: null,
});
